import { webhookEventToDisplayName } from '../../types'

export const SECRET_TOKEN_LENGTH = 32

export const WEBHOOK_EVENTS = [
	{
		id: 'contact.connected',
		name: webhookEventToDisplayName('contact.connected'),
		description: 'Triggered when you have a new connection on LinkedIn.'
	},
	{
		id: 'contact.scrapped',
		name: webhookEventToDisplayName('contact.scrapped'),
		description: 'Triggered when a contact’s profile data is successfully collected (scraped) by Snaily.'
	},
	{
		id: 'contact.notes.changed',
		name: webhookEventToDisplayName('contact.notes.changed'),
		description: 'Triggered when the Snaily notes field of a contact is updated.'
	},
	{
		id: 'contact.qualification.changed',
		name: webhookEventToDisplayName('contact.qualification.changed'),
		description: 'Triggered when a contact’s qualification status is updated.'
	},
	{
		id: 'invitation.sent',
		name: webhookEventToDisplayName('invitation.sent'),
		description: 'Triggered when a connection request is sent from your account via Snaily automation.'
	},
	{
		id: 'message.sent',
		name: webhookEventToDisplayName('message.sent'),
		description: 'Triggered when You or Snaily sent any message on LinkedIn.'
	},
	{
		id: 'message.received',
		name: webhookEventToDisplayName('message.received'),
		description: 'Triggered when a new incoming message is received in any LinkedIn conversation.'
	}
] as const